import request from "@/providers/requests";
import ENDPOINTS from "@/providers/end-points";
import Drivers from "@/modules/settings/drivers";
import { DriversType } from "@/types/settings/drivers";
import { Response } from "@/interface/response.interface";

const Driver = {
  namespaced: true,
  state: () => ({
    list: [],
    totalRows: 0,
    driver: {},
    success: false,
    message: "",
  }),
  getters: {
    list: (state: any) => state.list,
    totalRows: (state: any) => state.totalRows,
    driver: (state: any) => state.driver,
    success: (state: any) => state.success,
    message: (state: any) => state.message,
  },
  mutations: {
    SET_DRIVERS_LIST(state: any, payload: any) {
      state.list = payload.list;
      state.totalRows = payload.count;
    },
    SET_DRIVER_RESULT(state: any, payload: any) {
      state.driver = payload.driver;
      state.success = payload.success;
      state.message = payload.message;
    },
    SET_SUCCESS(state: any, success: any) {
      state.success = success;
    },
  },
  actions: {
    /**
     * get drivers from api , allows search by name and locations.
     * @param commit
     * @param locations
     * @param sorting
     * @param search
     */
    async getDrivers(
      { commit }: { commit: any },
      { locations, search = "", searchParameter = "search", sorting = "", queryParameters = "" }
    ) {
      let filters = queryParameters ? `&${queryParameters}` : "";
      return await request
        .get<Response<Array<DriversType>>>(
          `${ENDPOINTS.DRIVERS}?${searchParameter}=${search}&sorting=${sorting}&branch=${locations}${filters}`
        )
        .then((response) => response.data)
        .then(async ({ data, count }) => {
          const list = data.map((item) => new Drivers(item));
          await commit("SET_DRIVERS_LIST", { list, count });
        })
        .catch(async (error) => {
          await commit("SET_DRIVERS_LIST", { list: [], count: 0 });
          console.log(error);
        });
    },
    /**
     * get a single driver by his id
     * @param commit
     * @param driverId
     */
    async getDriver({ commit }: { commit: any }, driverId) {
      return await request
        .get(`${ENDPOINTS.DRIVERS}/${driverId}`)
        .then((response) => response.data)
        .then(async ({ data, count }) => {
          await commit("SET_DRIVER_RESULT", {
            driver: new Drivers(data),
            success: true,
            message: data.message || "",
          });
        })
        .catch(async (error) => {
          console.log(error);
        });
    },
    /**
     * create new driver
     * @param commit
     * @param Driver
     */
    async createDriver({ commit }: { commit: any }, Driver) {
      return await request
        .post(`${ENDPOINTS.DRIVERS}`, Driver)
        .then((response) => response.data)
        .then(
          async ({ data }) =>
            await commit("SET_DRIVER_RESULT", {
              driver: new Drivers(data),
              success: true,
              message: data.message || "",
            })
        )
        .catch(async (error) => {
          await commit("SET_DRIVER_RESULT", { driver: null, success: false, message: error.message || "" });
          console.log(error);
        });
    },
    /**
     * update existing driver
     * @param commit
     * @param Driver
     */
    async updateDriver({ commit }: { commit: any }, Driver) {
      return await request
        .put(`${ENDPOINTS.DRIVERS}/${Driver.id}`, Driver)
        .then((response) => response.data)
        .then(
          async ({ data }) =>
            await commit("SET_DRIVER_RESULT", {
              driver: new Drivers(data),
              success: true,
              message: data.message || "",
            })
        )
        .catch(async (error) => {
          await commit("SET_DRIVER_RESULT", { driver: null, success: false, message: error.message || "" });
          console.log(error);
        });
    },

    /**
     * delete  a driver using his id
     * @param commit
     * @param driverId
     */
    async deleteDriver({ commit }: { commit: any }, driverId) {
      return await request
        .delete(`${ENDPOINTS.DRIVERS}/${driverId}`)
        .then((response) => response.data)
        .catch(async (error) => {
          console.log(error);
        });
    },

    /**
     * delete  a driver using his id
     * @param commit
     * @param driverId
     */
    async deleteDrivers({ commit }: { commit: any }, data) {
      return await request
        .delete(`${ENDPOINTS.DRIVERS_BATCH}`, { data })
        .then(async (response) => await commit("SET_SUCCESS", true))
        .catch(async (error) => {
          await commit("SET_SUCCESS", false);
          console.log(error);
        });
    },

    async bulkEditDrivers({ commit }: { commit: any }, data) {
      return await request
        .put(`${ENDPOINTS.DRIVERS_BATCH}`, data)
        .then((response) => response.data)
        .then(async () => {
          await commit("SET_SUCCESS", true);
        })
        .catch(async (error) => {
          await commit("SET_SUCCESS", false);
          console.log(error);
        });
    },
  },
};

export default Driver;
